"use client";

import { useEffect, useRef } from "react";
import AppImage from "@/components/ui/AppImage";
import Icon from "@/components/ui/AppIcon";

const categories = [
{
  name: "Road Bikes",
  count: "34 models",
  image: "https://images.unsplash.com/photo-1708744505021-b9f3e0f8ca3a",
  alt: "Red road bicycle on a paved road with open countryside in background",
  icon: "BoltIcon"
},
{
  name: "Mountain Bikes",
  count: "28 models",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bb86b62a-1768219088459.png",
  alt: "Mountain bike on rugged rocky terrain with forest in background",
  icon: "MapIcon"
},
{
  name: "City & Commuter",
  count: "22 models",
  image: "https://images.unsplash.com/photo-1655444700890-d30bd37839fe",
  alt: "City commuter bicycle parked on a busy urban sidewalk",
  icon: "BuildingOfficeIcon"
},
{
  name: "Electric Bikes",
  count: "18 models",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_195335a15-1767784415212.png",
  alt: "Electric bicycle with visible battery pack on a city street at sunset",
  icon: "BoltIcon"
},
{
  name: "Kids & Youth",
  count: "14 models",
  image: "https://images.unsplash.com/photo-1692681261954-bbd8aaf9919b",
  alt: "Colorful kids bicycle with training wheels on a garden path",
  icon: "FaceSmileIcon"
},
{
  name: "Accessories",
  count: "200+ items",
  image: "https://images.unsplash.com/photo-1559142282-034e34b914ed",
  alt: "Cycling accessories including helmet, gloves, and water bottle on a wooden surface",
  icon: "CubeIcon"
}];


export default function CategoriesSection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.remove("hidden");
        });
      },
      { threshold: 0.05 }
    );
    const reveals = sectionRef?.current?.querySelectorAll(".reveal");
    reveals?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section id="categories" ref={sectionRef} className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-6">
          <div className="reveal hidden">
            <p className="text-xs font-bold uppercase tracking-[0.3em] text-amber mb-3">
              Browse by Type
            </p>
            <h2 className="font-heading text-5xl md:text-6xl font-black leading-none tracking-tight text-charcoal">
              Shop by{" "}
              <span className="italic font-light">Category.</span>
            </h2>
          </div>
          <a
            href="#"
            className="btn-outline inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm reveal hidden reveal-delay-2 self-start md:self-auto">
            
            View All
            <Icon name="ArrowRightIcon" size={16} />
          </a>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
          {categories?.map((cat, i) =>
          <a
            key={cat?.name}
            href="#"
            className={`category-card rounded-3xl block aspect-[4/3] reveal hidden reveal-delay-${i % 4 + 1}`}>
            
              <AppImage
              src={cat?.image}
              alt={cat?.alt}
              fill
              className="cat-img object-cover" />
            
              {/* Content overlay */}
              <div className="absolute inset-0 z-10 flex flex-col justify-end p-5">
                <p className="text-xs font-bold uppercase tracking-widest text-amber/80 mb-1">
                  {cat?.count}
                </p>
                <h3 className="font-heading text-xl md:text-2xl font-bold text-cream leading-tight">
                  {cat?.name}
                </h3>
              </div>
            </a>
          )}
        </div>
      </div>
    </section>);

}